import { Button, Modal, ModalClose, ModalDialog, Stack, Typography } from '@healthinal/ui';
import { ReactNode } from 'react';

export function DeleteConfirmationDialog({
  open,
  onCancel,
  onDelete,
  modalTitle,
  children,
}: {
  open: boolean;
  onCancel: () => void;
  onDelete: () => void;
  modalTitle: string;
  children: ReactNode;
}) {
  return (
    <Modal open={open} onClose={onCancel}>
      <ModalDialog sx={{ width: 500 }}>
        <ModalClose />
        <Typography level={'h4'}>{modalTitle}</Typography>
        <Stack gap={2}>
          <Stack>{children}</Stack>
          <Stack direction={'row'} justifyContent={'space-between'}>
            <Button onClick={onCancel}>Abbrechen</Button>
            <Button onClick={onDelete} color={'danger'}>
              Löschen
            </Button>
          </Stack>
        </Stack>
      </ModalDialog>
    </Modal>
  );
}
